
import Vue from 'vue';
import LeaseRequest from "@/components/Portal/MyRequest/LeaseRequest.vue";
import RegistrationRequestLayout from "@/components/common/RegistrationRequestLayout.vue";
import workflowService from "@/services/admin/workflowService";

export default Vue.extend({
  name: 'LeaseRequestCard',
  props: {
    requestId: { type: Number },
  },
  components: {
    LeaseRequest,
    RegistrationRequestLayout
  },
  data: function() {
      return {
          registration: {
              workflowGuid: "",
              requestId: 0
          } as any,
      };
  },
  computed: {
    workflowService() {
      return workflowService;
    },
  },
  methods: {
    onRequestProcessed: function (requestId: number) {
      this.$router.push({ path: `/admin/registration/leases` });
    },
  }
});
